module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "onlineDoctorList"
  }, [_c('scroller', {
    ref: "scrollerBottom",
    attrs: {
      "lock-x": "",
      "height": "200px",
      "scroll-bottom-offst": 200
    },
    on: {
      "on-scroll-bottom": _vm.onScrollBottom
    }
  }, [_c('div', {
    staticClass: "box2"
  }, [_vm._l((_vm.bottomCount), function(i) {
    return _c('p', [_vm._v("placeholder " + _vm._s(i))])
  }), _vm._v(" "), _c('load-more', {
    attrs: {
      "tip": "loading"
    }
  })], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bc39ed8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/onlineServicesProject/onlineDoctorList.vue
// module id = ZgqS
// module chunks = 5